// do these things only once
// even if you are using a history.js navigation

// imports --------------------------------------------------------------------
import * as Vars from './0-vars.js';
import * as Once from './2-once.js';
// import * as Page from './3-page.js';
import * as Resize from './4-resize.js';
import * as Scroll from './5-scroll.js';
import * as MediaItems from './6-media-items-v1.8.js';

// exported variables ---------------------------------------------------------
export let fromKeyboard = false;

// local variables ------------------------------------------------------------
const pulseSelector = '.button, .swiper-button-next, .swiper-button-prev'; // elements that get a pulse on click
let didPageInteraction = false; // to track first interaction for playing videos on low battery devices

let canClickSlider = true;
let sliderInterval = null;
const navSelector = '.nav__main-item, .nav__links-item, .nav .socials__item, .nav .buttons--switcher .button';

// listeners function ---------------------------------------------------------
export const initListeners = () => {
  // console.log('listeners');

  sliderInterval = setInterval(() => {
    const btnNextEl = document.querySelector('.slider .swiper-button-next');
    if (btnNextEl) btnNextEl.click();
  }, 4000);

  // touch --------------------------------
  const hoverSelector = 'button, a, input';
  document.body.addEventListener('touchstart', event => { // also triggers on move
    // console.log('touchstart', event.target.classList[0]);

    // add touch hover classes
    let el = event.target.closest(hoverSelector);
    if (el) el.classList.add('hover');
  });

  document.body.addEventListener('touchend', event => {
    // console.log('touchend', event.target.classList[0]);

    let el = event.target.closest(hoverSelector);
    if (el) el.classList.remove('hover');
  });

  // touch and mouse --------------------------------
  document.body.addEventListener('click', event => { // triggers on tap, not on move
    // console.log('click', event.target.classList[0]);

    // remove focus after click
    let el = event.target.closest('button, a, input[type="radio"], input[type="checkbox"], *[role="button"], input[type=range]');
    if (el && event.clientX !== 0 && event.clientY !== 0) el.blur();

    if ('aim' in Once && Once.aim) {
      Once.aim.classList.add('animate-it-mouse--click');

      setTimeout(() => {
        Once.aim.classList.remove('animate-it-mouse--click');
      }, Vars.transitionDefault); // same as .pulse duration
    }

    // pulse effect on buttons --------------------------------
    el = event.target.closest(pulseSelector);
    if (el) {
      const linkEl = el;
      linkEl.classList.add('pulse');

      setTimeout(() => {
        linkEl.classList.remove('pulse');
      }, Vars.transitionDefault); // same as .pulse duration
    }

    // play video on low battery devices  --------------------------------------------
    if (!didPageInteraction) {
      // actual autoplay videos, not ones that have autoplay from Fader.js
      const videoEls = document.querySelectorAll('video[autoplay]:not([data-autoplay="false"]):not([data-src=""])');
      videoEls.forEach(videoEl => videoEl.play());
      didPageInteraction = true;
    }

    // nav toggle --------------------------------
    el = event.target.closest('.header__nav-toggle');
    if (el) {
      document.body.classList.toggle('body--nav');
      Scroll.setColors(); // reset colors
      // Once.fader.fadeElementsAgain('.nav__main-item, .nav__links-item');
    }

    el = event.target.closest('.nav a, .header__logo, .event__foldout');
    if (el) {
      event.preventDefault();

      let timeout;
      if (el.closest('.nav') || el.classList.contains('header__logo')) {
        document.body.classList.remove('body--nav');
        timeout = 600;
      } else if (el.classList.contains('event__foldout')) {
        el.classList.add('event__foldout--inactive');
        timeout = 400;
      }

      // save for later
      const href = el.getAttribute('href');

      setTimeout(() => {
        location.href = href;
      }, 400);
    }

    el = event.target.closest('.drop-down__btn');
    if (el) {
      const dropDownEl = el.closest('.drop-down');
      if (dropDownEl) {
        dropDownEl.classList.toggle('drop-down--active');
      }
    } else {
      const dropDownEls = document.querySelectorAll('.drop-down');
      dropDownEls.forEach(dropDownEl => {
        dropDownEl.classList.remove('drop-down--active');
      });
    }

    // swiper -------------------------------
    el = event.target.closest('.swiper-button-next, .swiper-button-prev');
    if (el && canClickSlider) {
      // isTrusted is true when the event is triggered by a user action, false when triggered by code
      if (event.isTrusted) clearInterval(sliderInterval); // stop auto slide
      setTimeout(() => {
        canClickSlider = true; // allow click after timeout
      }, 1700); // same as longest slider speed
    }

    const sliderEls = document.querySelectorAll('.slider');
    el = event.target.closest('.swiper-button-next');
    if (el && canClickSlider) {
      canClickSlider = false; // prevent click until timeout
      sliderEls.forEach((sliderEl, id) => {
        const swiper = sliderEl.swiper;
        if (swiper) swiper.slideNext();
      });
    }

    el = event.target.closest('.swiper-button-prev');
    if (el && canClickSlider) {
      canClickSlider = false; // prevent click until timeout
      sliderEls.forEach((sliderEl, id) => {
        const swiper = sliderEl.swiper;
        if (swiper) swiper.slidePrev();
      });
    }

    // tickets button -------------------------------
    el = event.target.closest('.js-tickets-btn');
    if (el) {
      const datesEl = document.querySelector('.date');
      if (datesEl) Scroll.scrollToEl(datesEl);
    }

    // agenda -------------------------------
    el = event.target.closest('.event__header');
    if (el && !el.classList.contains('event__header--active')) {
      const eventEl = el.closest('.event');
      if (!eventEl) return;

      // load media
      const mediaEl = eventEl.querySelector('img, video');
      if (mediaEl && mediaEl.getAttribute('class') === null) {
        mediaEl.setAttribute('class', mediaEl.getAttribute('data-class'));
        Once.fader.setFaders();
      }

      const eventDesc = eventEl.querySelector('.event__desc');
      if (!eventDesc) return;

      const selector = '#' + eventDesc.getAttribute('id');

      setTimeout(() => {
        Once.fader.fadeInHolderAgain(selector);
      }, 300); // wait for fadein to begin
    }

    // agenda filter -------------------------------
    el = event.target.closest('.agenda__filter-icon');
    if (el) {
      const filterHolderEl = el.closest('.agenda__filter-holder');
      if (!filterHolderEl) return;

      const filterSelectEl = filterHolderEl.querySelector('.agenda__filter-select');
      if (!filterSelectEl) return;
      
      if (filterHolderEl.classList.contains('agenda__filter-holder--active')) {
        filterSelectEl.value = 'all'; // reset select
        filterHolderEl.classList.remove('agenda__filter-holder--active');
      }

      filterEvents(filterSelectEl.value); // filter events
    };

    // video popup
    el = event.target.closest('button.card__content');
    if (el) {
      const videoPopoverEl = document.querySelector(`.popover--video[data-video-id="${el.dataset.target}"]`);
      // console.log({el, videoPopoverEl});

      if (videoPopoverEl) {
        videoPopoverEl.classList.add('popover--active');
        Resize.setResize();
        Once.fader.setFaders(); // for video fade in
      }
    }

    el = event.target.closest('.popover__close, .popover__bg-btn');
    if (el) {
      const videoPopoverEl = el.closest('.popover');
      if (videoPopoverEl) {
        videoPopoverEl.classList.remove('popover--active');

        MediaItems.pauseMediaItems(videoPopoverEl);
        Resize.setResize();
      }
    }
  });

  // form submission --------------------------------
  document.body.addEventListener('submit', event => {
    let el = event.target.closest('.search__form');
    if (el) {
      // if less than 3 characters, don't submit
      const inputEl = el.querySelector('.search__input');
      if (inputEl && inputEl.value.length < 3) {
        event.preventDefault();
        inputEl.classList.add('search__input--error');

        inputEl.focus();
      } else {
        inputEl.classList.remove('search__input--error');
      }
    }

    el = event.target.closest('.js-newsletter-form');
    if (el) {
      event.preventDefault(); // prevent default form submission
      
      const formData = new FormData(el);
      const email = formData.get('EMAIL');
      const honeypot = formData.get('b_4cb1013fbbd4ec2d1cdab747a_27ddaf2105');
      
      // Basic validation
      if (!email || honeypot) {
        return;
      }
      
      // Show loading state
      const btn = el.querySelector('.newsletter__btn');
      const btnText = btn.querySelector('.newsletter__btn-text');
      const btnLoading = btn.querySelector('.newsletter__btn-loading');
      
      btn.disabled = true;
      btnText.style.display = 'none';
      btnLoading.style.display = 'inline';
      
      // Submit to Mailchimp
      const actionUrl = el.action;
      
      // Use JSONP to avoid CORS issues
      const script = document.createElement('script');
      const callbackName = 'newsletterCallback' + Date.now();
      
      // Create callback function
      window[callbackName] = function(data) {
        // Clean up
        document.head.removeChild(script);
        delete window[callbackName];
        
        // Reset button state
        btn.disabled = false;
        btnText.style.display = 'inline';
        btnLoading.style.display = 'none';
        
        // Get thank you page URL from data attribute or fallback to default
        const thankYouUrl = el.getAttribute('data-thank-you') || '/thank-you/';
        
        // Redirect to thank you page regardless of response
        // (Mailchimp sometimes returns error responses even for successful signups)
        window.location.href = thankYouUrl;
      };
      
      // Prepare URL with JSONP callback
      const url = new URL(actionUrl);
      url.searchParams.set('c', callbackName);
      url.searchParams.set('EMAIL', email);
      if (honeypot) url.searchParams.set('b_4cb1013fbbd4ec2d1cdab747a_27ddaf2105', honeypot);
      
      script.src = url.toString();
      document.head.appendChild(script);
    }
  });

  // keyboard --------------------------------
  document.body.addEventListener('keydown', event => {
    // console.log('keydown', event.key);
    fromKeyboard = true;
  });

  // mouse and keyboard --------------------------------
  // mouseout, focusout listeners 
  const outHandler = event => {
    // use if (event.type === 'mouseout') to avoid keyboard blur
    if (Vars.blTouch) return;
    if (event.type === 'focusout' && !fromKeyboard) return;
    // console.log('outHandler', event.target.classList[0], event.type);

    // let el = event.target.closest(swiperHoverSelector);
    // if (el && Once.aim) {
    //   Once.aim.classList.remove('animate-it-mouse--hover');
    // }

    // el = event.target.closest('.swiper-wrapper');
    // if (el && Once.aim) {
    //   Once.aim.classList.remove('animate-it-mouse--drag-hor');
    // }

    // nav hover --------------------------------
    let el = event.target.closest(navSelector);
    if (el && !Vars.blTouch) {
      const linkEls = document.querySelectorAll(navSelector);
      linkEls.forEach(linkEl => {
        linkEl.classList.remove('hover');
      });

      const navMediaEl = document.querySelector('.nav__media');
      if (navMediaEl) navMediaEl.classList.remove('nav__media--active');
    }

    // hiding sticky --------------------------------
    el = event.target.closest(Resize.stickySelector);
    if (el) Scroll.checkHideSticky();
  };

  // document.body.addEventListener('mouseleave', outHandler, true); // bubbles to body, triggers on touch
  document.body.addEventListener('mouseout', outHandler); // doesn't bubble, triggers on touch
  document.body.addEventListener('focusout', outHandler); // doesn't bubble or trigger on touch, triggers on keyboard blur and click on other button

  // mouseover, focusin listeners 
  const swiperHoverSelector = '.swiper-pagination-bullet, .swiper-button-next, .swiper-button-prev';
  const inHandler = event => {
    // use if (event.type === 'mouseover') to avoid keyboard focus
    if (Vars.blTouch) return;
    if (event.type === 'focusin' && !fromKeyboard) return;
    // console.log('inHandler', event.target.classList[0], event.type);

    // let el = event.target.closest(swiperHoverSelector);
    // if (el && Once.aim) {
    //   Once.aim.classList.add('animate-it-mouse--hover');
    // }

    // el = event.target.closest('.swiper-wrapper');
    // if (el && Once.aim) {
    //   Once.aim.classList.add('animate-it-mouse--drag-hor');
    // }

    // keyboard focus nav
    if (event.type == 'focusin' && fromKeyboard) {
      if( event.target.closest('.nav')) {
        document.body.classList.add('body--nav');
      } else {
        document.body.classList.remove('body--nav');
      }
      
      Scroll.setColors(); // reset colors
    }

    // nav hover --------------------------------
    let el = event.target.closest(navSelector);
    if (el && !Vars.blTouch) {
      // hover canonical link
      const href = el.getAttribute('href');
      const sameLinkEl = document.querySelectorAll(navSelector);

      // console.log({href, sameLinkEl});

      sameLinkEl.forEach(linkEl => {
        if (linkEl.getAttribute('data-href') === href) {
          linkEl.classList.add('hover');
        }
      });

      // show video in nav
      const navMediaEl = document.querySelector('.nav__media');
      const videoEl = document.querySelector('.nav__media video');
      const src = el.dataset.src;

      if (navMediaEl && videoEl && src) {
        navMediaEl.classList.add('nav__media--active')

        videoEl.dataset.src = src;
        Once.fader.fadeElementsAgain('.nav__media video')
      }
    }

    // event hover --------------------------------
    el = event.target.closest('.event__foldout');
    if (el && !Vars.blTouch) {
      const videoEl = el.querySelector('video');
      const src  = el.dataset.src;
      // const nr = el.dataset.nr;

      // console.log('event hover', videoEl, src);

      if (videoEl && src) {
        videoEl.dataset.src = src;
        Once.fader.fadeElementsAgain('.event__foldout video');
      }
    }

    // hiding sticky --------------------------------
    el = event.target.closest(Resize.stickySelector);
    if (el) {
      clearTimeout(Scroll.stickyTimeout); // don't hide it
      document.body.classList.remove('body--sticky-hidden');
    }
    
    fromKeyboard = false;
  };

  // document.body.addEventListener('mouseenter', inHandler, true); // bubbles to body, triggers on touch
  document.body.addEventListener('mouseover', inHandler); // doesn't bubble, triggers on touch
  document.body.addEventListener('focusin', inHandler); // doesn't bubble or trigger on touch, triggers on keyboard focus and mousedown on button

  // mousedown listener --------------------------------
  document.body.addEventListener('mousedown', event => {
    // console.log('mousedown', event.target.classList[0]);

    // el = event.target.closest('.swiper-wrapper');
    // if (el && Once.aim) {
    //   Once.aim.classList.add('animate-it-mouse--dragging-hor');
    // }
  }, true);

  // mousemove listener --------------------------------
  document.body.addEventListener('mousemove', event => {
    // console.log('mousemove', event.target.classList[0]);

    const x = event.clientX;
    const y = event.clientY;
  }, true);

  // mouseup listener --------------------------------
  document.body.addEventListener('mouseup', event => {
    // console.log('mouseup', event.target.classList[0]);

    // if (Once.aim) {
    //   Once.aim.classList.remove('animate-it-mouse--dragging-hor');
    // }
  }, true);

  // change select listener --------------------------------
  document.body.addEventListener('change', event => {
    // console.log('change', event.target.classList[0]);

    let el = event.target.closest('.agenda__filter-select');
    if (el) {
      const value = el.value;

      const filterHolderEl = el.closest('.agenda__filter-holder');
      if (!filterHolderEl) return;
      
      if (value === 'all') {
        filterHolderEl.classList.remove('agenda__filter-holder--active');
      } else {
        filterHolderEl.classList.add('agenda__filter-holder--active');
      }

      filterEvents(value); // filter events

      el.blur();
    }
  });
};

// functions -------------------------------------------------------------------
const filterEvents = (value) => {
  const eventsEl = document.querySelector('.agenda__events');
  if (!eventsEl) return;

  eventsEl.classList.add('agenda__events--faded-out');

  setTimeout(() => {
    eventsEl.classList.remove('agenda__events--faded-out');

    // earlier so it doesn't remove event--hidden class
    Once.fader.fadeInHolderAgain('.agenda__events');

    const eventEls = document.querySelectorAll('.event');
    eventEls.forEach(eventEl => {
      if (value === 'all' || eventEl.dataset.city === value) {
        eventEl.classList.remove('event--hidden');
      } else {
        eventEl.classList.add('event--hidden');
      }
    });
  }, 400);
};
